import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import PropTypes from "prop-types";

import { I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";

import { setAlert } from "../../../actions/alertActions";
import { lottieModule } from "../Utils";

const { lottie } = lottieModule;

class ChargeAnimation extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;
    this.elContainer = null;

    this.state = {
      animation: null,
    };

    this.loadAnimation = this.loadAnimation.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.animation === null) this.loadAnimation();
  }

  componentWillUnmount() {
    this.safeSetState({ animation: null }, () => {
      if (this.cancel !== null) this.cancel("Component is unmounting");
      this._mounted = false;
    });
  }

  loadAnimation() {
    if (this.elContainer) {
      const animation = lottie.loadAnimation({
        container: this.elContainer,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: lottieModule.getAnimation(this.props.chargerType),
      });
      this.safeSetState({ animation }, () => {
        if (this.props.direction === -1) {
          animation.setDirection(-1);
          animation.addEventListener("DOMLoaded", () => {
            var counter = 0;
            const interval = setInterval(() => {
              if (counter < 40)
                axios
                  .get("/api/private/chargingSession/myActiveSessions", {
                    cancelToken: new CancelToken((c) => (this.cancel = c)),
                  })
                  .then((res) => {
                    if (res.status === 200) {
                      if (Array.isArray(res.data))
                        if (
                          !res.data.some((s) => s._id === this.props.sessionId)
                        ) {
                          clearInterval(interval);
                          animation.stop();
                          this.props.onHide();
                          //window.location.assign("../insights");
                        }
                    }
                  })
                  .catch((err) =>
                    this.props.setAlert(
                      I18n.t(err.response.data.message),
                      "danger"
                    )
                  )
                  .finally(() => counter++);
              else {
                clearInterval(interval);
                animation.stop();
                this.props.onHide();
              }
            }, 5 * 1000);
          });
        } else {
          animation.setDirection(1);
          animation.addEventListener("DOMLoaded", () => {
            var counter = 0;
            const interval = setInterval(() => {
              if (counter < 40)
                axios
                  .get("/api/private/chargingSession/myActiveSessions")
                  .then((res) => {
                    if (res.status === 200) {
                      if (Array.isArray(res.data))
                        if (
                          res.data.some(
                            (s) =>
                              s._id === this.props.sessionId &&
                              parseInt(s.status) === 20
                          )
                        ) {
                          clearInterval(interval);
                          window.location.assign("../sessions");
                          animation.stop();
                          this.props.onHide();
                        }
                    }
                  })
                  .catch((err) =>
                    this.props.setAlert(
                      I18n.t(err.response.data.message),
                      "danger"
                    )
                  )
                  .finally(() => counter++);
              else {
                clearInterval(interval);
                animation.stop();
                this.props.onHide();
              }
            }, 5 * 1000);
          });
        }
      });
    }
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <Modal
        id="chargeAnimation"
        show={this.props.show}
        onHide={this.props.onHide}
        backdrop="static"
        centered
      >
        <Modal.Body>
          <div
            ref={(el) => (this.elContainer = el)}
            style={{ height: "40vh" }}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

ChargeAnimation.propTypes = {
  chargerType: PropTypes.any.isRequired,
  sessionId: PropTypes.any.isRequired,
  direction: PropTypes.number,
};

export default connect(null, { setAlert })(ChargeAnimation);
